/* eslint-disable react/require-default-props */
import React from 'react';

import Icon, { IconName, IconSize } from 'components/atoms/Icon';
import Loading from 'components/atoms/Loading';
import mapModifiers from 'utils/functions';

type Variant = 'primary' | 'secondary' | 'outline'
| 'whiteBgPurpleText' | 'error' | 'whiteBgPrimaryLinearText'
| 'transparentBg' | 'gray' | 'primaryLinearReverse'
| 'flameLinear' | 'flameOutlineLinear' | 'joinRegisterModal' | 'default';

type Sizes = 'lg' | 'lg-m' | 'lg-s' | 'md' | 'sm' | 'smaller' | 'h24' | 'h28';

type Paddings = 'pd-x-10' | 'pd-x-12' | 'pd-x-16' | 'pd-x-22' | 'pd-x-18' | 'pd-x-none';

type PaddingIcons = 'pd-r6' | 'pd-r8';

type FontsizeText = 'f14x20';

interface ButtonProps {
  modifiers?: (Sizes | Variant | GeneralTextStyle | Paddings | FontsizeText)[];
  isSubmit?: boolean;
  disabled?: boolean;
  loading?: boolean;
  handleClick?: () => void;
  iconName?: IconName;
  isLeftIcon?: boolean;
  paddingIcon?: PaddingIcons;
  iconSize?: IconSize;
}

const modifiersOverlay = ['outline', 'joinRegisterModal'];

const Button: React.FC<ButtonProps> = ({
  isSubmit,
  children,
  handleClick,
  modifiers,
  loading,
  disabled,
  iconName,
  isLeftIcon,
  paddingIcon,
  iconSize,
}) => (
  <button
    className={mapModifiers(
      'a-button',
      modifiers,
      loading && 'loading',
      iconName && 'icon',
      isLeftIcon && 'left-icon',
    )}
    onClick={handleClick}
    type={isSubmit ? 'submit' : 'button'}
    disabled={disabled || loading}
  >
    {loading ? <Loading isShow variant="default" size="small" /> : (
      <>
        {modifiers?.some((i) => modifiersOverlay.includes(i)) && <span className="a-button_overlay" />}
        <span>
          {children}
        </span>
        {iconName && (
        <span className={mapModifiers('a-button_icon', paddingIcon)}>
          <Icon iconName={iconName} size={iconSize} />
        </span>
        )}
      </>
    )}
  </button>
);

Button.defaultProps = {
  modifiers: ['primary', '700', 'uppercase'],
  loading: false,
  disabled: false,
  iconName: undefined,
  handleClick: undefined,
  isSubmit: false,
  isLeftIcon: false,
};

export default Button;
